import { initFormModalLinks } from '../../shared/formModal.js';

// The Konzern's detail page. One job: the header's "Bearbeiten" button opens the
// group's form in the shared dialog rather than navigating to it, exactly as the
// same button does on the list.
//
// Anchored on /konzerne/…/edit rather than any href ending in /edit, so a link
// to some other resource's form that happens to end the same way is left alone.
// The page carries no Verlauf column, so unlike the customer's there is no note
// form to exclude here.
export function initKonzernDetail() {
  const detail = document.getElementById('konzern-detail');
  if (!detail) return;

  initFormModalLinks({
    // A save reloads: this page is composed server-side - the header, the
    // Stammdaten card and the Kennzahlen all read the record - so refetching one
    // region would leave the others showing the old values.
    selector: 'a[href^="/konzerne/"][href$="/edit"]',
    onSaved: () => window.location.reload()
  });
}
